import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, PageEvent } from '@angular/material';
import { PrecificacaoUF } from '../models/precificacao-uf';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { PaginatorService } from '../services/paginator.service';
import { PrecificacaoUFService } from '../services/precificacao-uf.service';
import swal from 'sweetalert2';
import { CadastrarPrecificacaoUFModalComponent } from '../modals/precificacao-ufmodal/cadastrar-precificacao-ufmodal/cadastrar-precificacao-ufmodal.component';
import { PremissasSistema } from '../models/premissas-sistema';
import { PremissasService } from '../services/premissas.service';
import { Router } from '@angular/router';

// jquery
declare const $: any;

@Component({
  selector: 'app-precificacao-uf',
  templateUrl: './precificacao-uf.component.html',
  styleUrls: ['./precificacao-uf.component.scss']
})
export class PrecificacaoUfComponent implements OnInit {

  premissasSistema: PremissasSistema = new PremissasSistema();
  precificacoes: PrecificacaoUF[];

  campoOrdenacao = 'uf';
  ordenarDesc = false;
  filtroDescricao = '';
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;

  tipoDa = [{ id: 0, descricao: 'Desconto' }, { id: 1, descricao: 'Acréscimo' }];
  tipoDaSelecionado = undefined;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(private dialog: MatDialog,
    private precificacaoUFService: PrecificacaoUFService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private paginatorService: PaginatorService,
    private premissasService: PremissasService, private router: Router) { }

  async ngOnInit() {

    await this.buscarPremissasSistema();

    if (!this.premissasSistema.usarPrecificacaoPorUF) {
      this.router.navigate(['/']);
    }

    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarPrecificacoes();
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({
        length: this.paginator.length,
        pageIndex: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
      });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarPrecificacoes();
  }

  filtra() {
    this.buscarPrecificacoes();
    this.paginator.firstPage();
  }

  buscarPrecificacoes() {
    this.carregandoService.mostra('buscarPrecificacoes');

    this.precificacaoUFService.consultarComPaginacao(
      this.filtroDescricao,
      this.paginacao.paginaAtual,
      this.itensPorPagina,
      this.campoOrdenacao,
      this.ordenarDesc ? 'desc' : 'asc',
      this.tipoDaSelecionado
    )
      .subscribe(
        (dados) => {
          this.precificacoes = dados.itens;
          if (
            this.itensPorPagina >
            this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]
          ) {
            this.itensPorPagina = 10;
          }

          this.paginacao.total = dados.total;

          this.carregandoService.esconde('buscarPrecificacoes');
        },
        (erro) => {
          this.carregandoService.esconde('buscarPrecificacoes');
          this.notificacaoService.erro(erro);
        }
      );
  }

  novaPrecificacao() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarPrecificacaoUFModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { item: new PrecificacaoUF(), itens: this.precificacoes },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: PrecificacaoUF) => {
      if (result) {
        this.salvar(result);
      }
    });
  }

  editarPrecificacao(item: PrecificacaoUF) {
    const itemParaEditar = new PrecificacaoUF();

    Object.assign(itemParaEditar, item);

    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarPrecificacaoUFModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { item: itemParaEditar, itens: this.precificacoes.filter(p => p !== item) },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: PrecificacaoUF) => {
      if (result) {
        this.salvar(result);
      }
    });
  }

  salvar(item: PrecificacaoUF) {



    item.percentual = Number(item.percentual);

    this.carregandoService.mostra('salvar');
    this.precificacaoUFService.salvar(item).subscribe(
      () => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.sucesso('Precificação adicionada com sucesso!!!');
        this.buscarPrecificacoes();
      },
      err => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.erro(err);
      }
    );
  }

  excluirPrecificacao(item: PrecificacaoUF) {
    swal({
      title: 'Deseja realmente Excluir?',
      text: '',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false,
      type: 'warning'
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluir');
        this.precificacaoUFService.excluir(item.uf).subscribe(
          () => {
            this.carregandoService.esconde('excluir');
            this.notificacaoService.sucesso('Precificação excluída com sucesso!!!');
            this.buscarPrecificacoes();
          },
          err => {
            this.carregandoService.esconde('excluir');
            this.notificacaoService.erro(err);
          }
        );
      }
    });
  }

}
